import stylesC from '../../styles/common.module.css';
import HomeMainSection from '../../components/home/HomeMainSection';
import HomeOverviewSection from '../../components/home/HomeOverviewSection';
import HomeTechnologiesSection from '../../components/home/HomeTechnologiesSection';
import HomeProductSection from '../../components/home/HomeProductSection';



export default function HomePage() {
    return (
        <main className={` ${stylesC.main}`}>
            <section className={` ${stylesC.section}`}>
                <HomeMainSection />
            </section>
            <section className={` ${stylesC.section}`}>
                <HomeOverviewSection />
            </section>
            <section className={`${stylesC.section}`}>
                <HomeTechnologiesSection />
            </section>
            <section className={` ${stylesC.section}`}>
                <HomeProductSection />
            </section>
        </main>
    )
}
